/**
 * DEVELOPER DOCUMENTATION
 *
 * Include your custom JavaScript here.
 *
 * The theme Focal has been developed to be easily extensible through the usage of a lot of different JavaScript
 * events, as well as the usage of custom elements (https://developers.google.com/web/fundamentals/web-components/customelements)
 * to easily extend the theme and re-use the theme infrastructure for your own code.
 *
 * The technical documentation is summarized here.
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A VARIANT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a the user has changed the variant in a selector. The target get you the form
 * that triggered this event.
 *
 * Example:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   let variant = event.detail.variant; // Gives you access to the whole variant details
 *   let form = event.target;
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * MANUALLY CHANGE A VARIANT
 * ------------------------------------------------------------------------------------------------------------
 *
 * You may want to manually change the variant, and let the theme automatically adjust all the selectors. To do
 * that, you can get the DOM element of type "<product-variants>", and call the selectVariant method on it with
 * the variant ID.
 *
 * Example:
 *
 * const productVariantElement = document.querySelector('product-variants');
 * productVariantElement.selectVariant(12345);
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN A NEW VARIANT IS ADDED TO THE CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever a variant is added to the cart through a form selector (product page, quick
 * view...). This event DOES NOT include any change done through the cart on an existing variant. For that,
 * please refer to the "cart:updated" event.
 *
 * Example:
 *
 * document.addEventListener('variant:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * BEING NOTIFIED WHEN THE CART CONTENT HAS CHANGED
 * ------------------------------------------------------------------------------------------------------------
 *
 * This event is fired whenever the cart content has changed (if the quantity of a variant has changed, if a variant
 * has been removed, if the note has changed...). This event will also be emitted when a new variant has been
 * added (so you will receive both "variant:added" and "cart:updated"). Contrary to the variant:added event,
 * this event will give you the complete details of the cart.
 *
 * Example:
 *
 * document.addEventListener('cart:updated', function(event) {
 *   var cart = event.detail.cart; // Get the updated content of the cart
 * });
 *
 * ------------------------------------------------------------------------------------------------------------
 * REFRESH THE CART/MINI-CART
 * ------------------------------------------------------------------------------------------------------------
 *
 * If you are adding variants to the cart and would like to instruct the theme to re-render the cart, you cart
 * send the cart:refresh event, as shown below:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 *
 * ------------------------------------------------------------------------------------------------------------
 * USAGE OF CUSTOM ELEMENTS
 * ------------------------------------------------------------------------------------------------------------
 *
 * Our theme makes extensive use of HTML custom elements. Custom elements are an awesome way to extend HTML
 * by creating new elements that carry their own JavaScript for adding new behavior. The theme uses a large
 * number of custom elements, but the two most useful are drawer and popover. Each of those components add
 * a "open" attribute that you can toggle on and off. For instance, let's say you would like to open the cart
 * drawer, whose id is "mini-cart", you simply need to retrieve it and set its "open" attribute to true (or
 * false to close it):
 *
 * document.getElementById('mini-cart').open = true;
 *
 * Thanks to the power of custom elements, the theme will take care automagically of trapping focus, maintaining
 * proper accessibility attributes...
 *
 * If you would like to create your own drawer, you can re-use the <drawer-content> content. Here is a simple
 * example:
 *
 * // Make sure you add "aria-controls", "aria-expanded" and "is" HTML attributes to your button:
 * <button type="button" is="toggle-button" aria-controls="id-of-drawer" aria-expanded="false">Open drawer</button>
 *
 * <drawer-content id="id-of-drawer">
 *   Your content
 * </drawer-content>
 *
 * The nice thing with custom elements is that you do not actually need to instantiate JavaScript yourself: this
 * is done automatically as soon as the element is inserted to the DOM.
 *
 * ------------------------------------------------------------------------------------------------------------
 * THEME DEPENDENCIES
 * ------------------------------------------------------------------------------------------------------------
 *
 * While the theme tries to keep outside dependencies as small as possible, the theme still uses third-party code
 * to power some of its features. Here is the list of all dependencies:
 *
 * "vendor.js":
 *
 * The vendor.js contains required dependencies. This file is loaded in parallel of the theme file.
 *
 * - custom-elements polyfill (used for built-in elements on Safari - v1.0.0): https://github.com/ungap/custom-elements
 * - web-animations-polyfill (used for polyfilling WebAnimations on Safari 12, this polyfill will be removed in 1 year - v2.3.2): https://github.com/web-animations/web-animations-js
 * - instant-page (v5.1.0): https://github.com/instantpage/instant.page
 * - tocca (v2.0.9); https://github.com/GianlucaGuarini/Tocca.js/
 * - seamless-scroll-polyfill (v2.0.0): https://github.com/magic-akari/seamless-scroll-polyfill
 *
 * "flickity.js": v2.2.0 (with the "fade" package). Flickity is only loaded on demand if there is a product image
 * carousel on the page. Otherwise it is not loaded.
 *
 * "photoswipe": v4.1.3. PhotoSwipe is only loaded on demand to power the zoom feature on product page. If the zoom
 * feature is disabled, then this script is never loaded.
 */

document.addEventListener("DOMContentLoaded", function () {
  $(".redirecting-popup-con").each(function () {
    const $this = $(this);
    const $timeSpan = $this.find("span[ac-popup-time]");
    const endTime = $this.data("end_time");
    const endDate = new Date(endTime);
    const redirectUrl = $this.data("redirect_url");
    let jumpTime = Number($this.data("jump_time")) || 0;
    let intervalA = null,
      intervalB = null;

    function jumpTimer() {
      if (jumpTime <= 1) {
        if (jumpTime > 0) $timeSpan?.text(0);
        clearInterval(intervalB);
        redirectUrl && window.location.replace(redirectUrl);
        return;
      }
      jumpTime--;
      $timeSpan?.text(jumpTime);
    }

    function endTimer() {
      const nowDate = new Date();
      if (nowDate < endDate) return;

      clearInterval(intervalA);
      $this.parent().removeClass("hide");
      $("html").addClass("lock-all");
      intervalB = setInterval(jumpTimer, 1000);
    }

    intervalA = setInterval(endTimer, 1000);
    endTimer();
  });

  $(".cs-countdown-timer").each(function () {
    const $this = $(this);
    let interval = null;
    let startTime = $this.data("start_time") || "";
    let startDate = new Date(startTime);
    let endTime = $this.data("end_time") || "";
    let endDate = new Date(endTime);
    // console.log('开始时间：', startDate);
    // console.log('结束时间：', endDate);

    let $tips = $this.find(".countdown-timer-tips");
    let $days = $this.find(".cd-days");
    let $hours = $this.find(".cd-hours");
    let $minutes = $this.find(".cd-minutes");
    let $seconds = $this.find(".cd-seconds");

    function updateCountdown() {
      const nowDate = new Date();
      let diff = 0;
      // console.log('当前时间：', nowDate);
      if (endDate <= nowDate) {
        clearInterval(interval);
        $days.text("00");
        $hours.text("00");
        $minutes.text("00");
        $seconds.text("00");
        return;
      } else if (nowDate < startDate) {
        diff = endDate - startDate;
        if (!$tips.hasClass("show")) {
          $tips.addClass("show");
        }
      } else {
        diff = endDate - nowDate;
        if ($tips.hasClass("show")) {
          $tips.removeClass("show");
        }
      }

      const days = Math.floor(diff / (1000 * 60 * 60 * 24));
      const hours = Math.floor(
        (diff % (1000 * 60 * 60 * 24)) / (1000 * 60 * 60)
      );
      const minutes = Math.floor((diff % (1000 * 60 * 60)) / (1000 * 60));
      const seconds = Math.floor((diff % (1000 * 60)) / 1000);
      $days.text(String(days).padStart(2, "0"));
      $hours.text(String(hours).padStart(2, "0"));
      $minutes.text(String(minutes).padStart(2, "0"));
      $seconds.text(String(seconds).padStart(2, "0"));
    }

    updateCountdown();
    interval = setInterval(updateCountdown, 1000);
  });

  $(".product-purchase-con").each(function () {
    const $this = $(this);
    const $variantSelect = $this.find("select.variant-select");
    const $price = $this.find(".price.price--highlight");
    const $compare_price = $this.find(".price.price--compare");
    const $buy_now_btn = $this.find(".buy-now-btn");
    const cart_url = $buy_now_btn?.data("cart_url") || "/cart";
    const $quantityInput = $this.find(".quantity-selector-input");
    const $add_cart_btn = $this.find(".add-cart-btn");
    const addCartText = $add_cart_btn.data("add_to_cart");
    const soldOutText = $add_cart_btn.data("sold_out");
    $this
      .find(".product-variant-options .option-item")
      .on("click", function () {
        let value = $(this).data("value");
        let position = $(this).parent().data("position");
        let $activeImg = $this.find(".product-img.active");
        let options = $activeImg.data("title").split(" / ");
        options[position - 1] = value;
        let newTitle = options.join(" / ");
        let $newImg = $this.find(".product-img").filter(function () {
          return $(this).data("title") === newTitle;
        });
        if ($newImg.length > 0) {
          let id = $newImg.data("id");
          let available = $newImg.data("available");
          let price = $newImg.data("price") || "";
          let compare_price = $newImg.data("compare_price") || "";
          $price.text(price);
          $compare_price.text(compare_price);
          $newImg.addClass("active");
          $activeImg.removeClass("active");
          $(this).addClass("active").siblings().removeClass("active");
          $(this)
            .parent()
            .siblings(".product-option-title")
            .find("span")
            .text(value);
          $variantSelect.val(id).trigger("change");
          if ($buy_now_btn.length > 0) {
            if (available) {
              let quantity = parseInt($quantityInput.val(), 10) || 1;
              $buy_now_btn.attr("href", `${cart_url}/${id}:${quantity}`);
              $buy_now_btn.removeClass("disabled");
            } else {
              $buy_now_btn.attr("href", "#");
              $buy_now_btn.addClass("disabled");
            }
          }
          if (available) {
            $add_cart_btn.attr("disabled", false);
            $add_cart_btn.find(".loader-button__text").text(addCartText);
          } else {
            $add_cart_btn.attr("disabled", true);
            $add_cart_btn.find(".loader-button__text").text(soldOutText);
          }
        }
      });
    if ($buy_now_btn.length > 0) {
      $quantityInput.on("change", function () {
        let id = $this.find(".product-img.active").data("id");
        let quantity = parseInt($(this).val(), 10) || 1;
        $buy_now_btn.attr("href", `${cart_url}/${id}:${quantity}`);
      });
    }
  });

  $(".custom-product-list").each(function () {
    const $this = $(this);
    const $swiper = $this.find(".product-list-con.swiper");
    if ($swiper.length == 0) return;

    const swiper = new Swiper($swiper[0], {
      slidesPerView: "auto",
      centerInsufficientSlides: true,
      scrollbar: {
        el: $swiper.find(".swiper-scrollbar"),
      },
    });

    $this.find(".product-item").each(function () {
      const $productDom = $(this);
      const $variantSelect = $productDom.find("select.variant-select");
      const $price = $productDom.find(".price.price--highlight");
      const $compare_price = $productDom.find(".price.price--compare");
      const $buy_now_btn = $productDom.find(".buy-now-btn");
      const cart_url = $buy_now_btn?.data("cart_url") || "/cart";
      const $quantityInput = $productDom.find(".quantity-selector-input");
      const $add_cart_btn = $productDom.find(".add-cart-btn");
      const addCartText = $add_cart_btn.data("add_to_cart");
      const soldOutText = $add_cart_btn.data("sold_out");

      $productDom.find(".option-item").on("click", function () {
        let value = $(this).data("value");
        let position = $(this).parent().data("position");
        let $activeImg = $productDom.find(".product-img.active");
        let options = $activeImg.data("title").split(" / ");
        options[position - 1] = value;
        let newTitle = options.join(" / ");
        let $newImg = $productDom.find(".product-img").filter(function () {
          return $(this).data("title") === newTitle;
        });
        if ($newImg.length > 0) {
          let id = $newImg.data("id");
          let available = $newImg.data("available");
          let price = $newImg.data("price") || "";
          let compare_price = $newImg.data("compare_price") || "";
          $price && $price.text(price);
          $compare_price && $compare_price.text(compare_price);
          $newImg.addClass("active");
          $activeImg.removeClass("active");
          $(this).addClass("active").siblings().removeClass("active");
          // $(this).parent().siblings('.product-option-title').find('span').text(value);
          $variantSelect.val(id).trigger("change");
          if ($buy_now_btn.length > 0) {
            if (available) {
              let quantity = parseInt($quantityInput.val(), 10) || 1;
              $buy_now_btn.attr("href", `${cart_url}/${id}:${quantity}`);
              $buy_now_btn.removeClass("disabled");
            } else {
              $buy_now_btn.attr("href", "#");
              $buy_now_btn.addClass("disabled");
            }
          }
          if (available && $add_cart_btn.length > 0) {
            $add_cart_btn.attr("disabled", false);
            $add_cart_btn.find(".loader-button__text").text(addCartText);
          } else {
            $add_cart_btn.attr("disabled", true);
            $add_cart_btn.find(".loader-button__text").text(soldOutText);
          }
        }
      });
      if ($buy_now_btn.length > 0) {
        $quantityInput.on("change", function () {
          let id = $productDom.find(".product-img.active").data("id");
          let quantity = parseInt($(this).val(), 10) || 1;
          $buy_now_btn.attr("href", `${cart_url}/${id}:${quantity}`);
        });
      }
      $productDom.find(".detail-tab-header").on("click", function () {
        $(this).parent().toggleClass("show");
      });
    });
  });
  $(".custom-kol-list").each(function () {
    const playButtons = document.querySelectorAll(".video-btn");
    const modal = document.getElementById("video-modal");
    const iframe = document.getElementById("youtube-iframe");
    const closeBtn = document.getElementById("close-btn");

    playButtons.forEach((button) => {
      button.addEventListener("click", function () {
        console.log(
          "data-video-id",
          this.parentElement.getAttribute("data-video-id")
        );
        const videoId = this.parentElement.getAttribute("data-video-id");
        iframe.src = `https://www.youtube.com/embed/${videoId}?autoplay=1&mute=1`;
        modal.style.display = "flex";
      });
    });

    closeBtn.addEventListener("click", function () {
      iframe.src = "";
      modal.style.display = "none";
    });

    document
      .getElementById("video-modal")
      .addEventListener("click", function (e) {
        if (e.target === this) {
          this.style.display = "none";
          document.getElementById("youtube-iframe").innerHTML = "";
        }
      });
    const $this = $(this);
    const $swiper = $this.find(".product-list-con.swiper");
    if ($swiper.length == 0) return;

    const swiper = new Swiper($swiper[0], {
      slidesPerView: "auto",
      scrollbar: {
        el: $swiper.find(".swiper-scrollbar"),
      },
    });
  });
  // custom-comparison-list js
  $(".custom-comparison-list").each(function () {
    function syncHeights() {
      const $divs1 = $(".custom-comparison-list .product-title");
      const $divs2 = $(".custom-comparison-list .comparion-product-image");

      let maxHeight1 = 0;
      let maxHeight2 = 0;
      $divs1.css("height", "auto");
      $divs2.css("height", "auto");

      $divs1.each(function () {
        const currentHeight = $(this).height();
        if (currentHeight > maxHeight1) {
          maxHeight1 = currentHeight;
        }
      });
      $divs2.each(function () {
        const currentHeight = $(this).height();
        if (currentHeight > maxHeight2) {
          maxHeight2 = currentHeight;
        }
      });
      $divs1.height(maxHeight1);
      $divs2.height(maxHeight2);
    }
    syncHeights();
    let resizeTimer;
    $(window).resize(function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(syncHeights, 500);
    });

    $(".custom-comparison-list").on("click", ".option-item", function () {
      const dataValue = $(this).data("value");
      const $productItem = $(this).closest(".product-item");
      $productItem.find(".product-img, .option-item").removeClass("active");
      $(this).addClass("active");
      $productItem
        .find(`.product-img[data-title="${dataValue}"]`)
        .addClass("active");
    });
  });
  //custom-view-list
  $(".custom-view-list").each(function () {
    const tabsContainer = document.getElementById("tabs-view-container");
    const scrollLeftBtn = document.getElementById("scroll-left");
    const container = document.getElementById("custom-view-list");
    const tabButtons = container.querySelectorAll(".tab-btn");
    let autoPlayInterval = null;
    let progressInterval = null;
    const scrollRightBtn = document.getElementById("scroll-right");
    const time = container.getAttribute("data-time") * 1000 || 3000;
    let currentIndex = 0;
    const scrollAmount = tabsContainer.getAttribute("data-distance") || 200;
    scrollLeftBtn.classList.add("hidden");
    function scrollTabToCenter(index) {
      const tab = tabButtons[index];
      const containerWidth = tabsContainer.clientWidth;
      const tabLeft = tab.offsetLeft;
      const tabWidth = tab.offsetWidth;
      const scrollPosition = tabLeft + tabWidth / 2 - containerWidth / 2;
      const maxScroll = tabsContainer.scrollWidth - containerWidth;
      const targetPosition = Math.max(0, Math.min(maxScroll, scrollPosition));
      tabsContainer.scrollTo({
        left: targetPosition,
        behavior: "smooth",
      });
    }
    scrollRightBtn.addEventListener("click", () => {
      tabsContainer.scrollBy({ left: scrollAmount, behavior: "smooth" });
    });
    scrollLeftBtn.addEventListener("click", () => {
      tabsContainer.scrollBy({ left: -scrollAmount, behavior: "smooth" });
    });
    tabsContainer.addEventListener("scroll", updateButtonVisibility);
    function updateButtonVisibility() {
      if (tabsContainer.scrollLeft <= 0) {
        scrollLeftBtn.classList.add("hidden");
      } else {
        scrollLeftBtn.classList.remove("hidden");
      }
      const maxScrollLeft =
        tabsContainer.scrollWidth - tabsContainer.clientWidth;
      if (Math.ceil(tabsContainer.scrollLeft) >= Math.floor(maxScrollLeft)) {
        scrollRightBtn.classList.add("hidden");
      } else {
        scrollRightBtn.classList.remove("hidden");
      }
    }
    const swiper = new Swiper(`.swiper-view`, {
      effect: "fade",
      fadeEffect: { crossFade: true },
      loop: false,
      autoHeight: true,
      pagination: {
        el: ".swiper-view .swiper-pagination",
        clickable: true,
      },
      autoplay: {
        delay: time,
        disableOnInteraction: false,
      },
    });

    function activateTab(index) {
      currentIndex = index;
      tabButtons.forEach((btn) => btn.classList.remove("active"));
      tabButtons[index].classList.add("active");
      scrollTabToCenter(index);
      swiper.slideTo(index);
      startProgressBar(index);
    }
    function startProgressBar(index) {
      clearInterval(progressInterval);
      clearInterval(autoPlayInterval);
      const progressBar = tabButtons[index].querySelector(".progress-bar");
      if (!progressBar) return;
      progressBar.style.width = "0";
      let width = 0;
      const increment = 100 / (time / 50);

      progressInterval = setInterval(() => {
        if (width >= 100) {
          clearInterval(progressInterval);
          return;
        }
        width += increment;
        progressBar.style.width = `${width}%`;
      }, 50);

      autoPlayInterval = setInterval(() => {
        let nextIndex = index + 1;
        if (nextIndex >= tabButtons.length) nextIndex = 0;
        activateTab(nextIndex);
      }, time);
    }

    tabButtons.forEach((button, index) => {
      button.addEventListener("click", () => {
        activateTab(index);
      });
    });

    swiper.on("slideChange", () => {
      const activeIndex = swiper.activeIndex;
      tabButtons.forEach((button, index) => {
        if (index === activeIndex) {
          button.classList.add("active");
          startProgressBar(activeIndex);
        } else {
          button.classList.remove("active");
          tabButtons[index].querySelector(".progress-bar").style.width = "0";
        }
      });
    });
    window.addEventListener("resize", () => {
      scrollTabToCenter(currentIndex);
      updateButtonVisibility();
    });
    if (tabButtons.length > 0) {
      activateTab(0);
    }
  });
});
